<template>
  <label class="mb-0" :class="getClass" :disabled="uploading">
    <slot></slot> <base-icon class="ml-1" :icon="uploading ? 'spinner' : 'cloud-upload-alt'" :spin="uploading" />
    <input ref="input" hidden name="file" type="file" @change="preview" @input="go" />
  </label>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import BaseButton from './BaseButton.vue'

export default {
  name: 'ButtonUpload',

  extends: BaseButton,

  props: {
    caption: String,
    description: String,
    path: String,
    requiresInternalSignature: Boolean,
    requiresSignature: Boolean,
    sent: Boolean,
    tag: String
  },

  computed: {
    sentAt () {
      return this.sent ? this.$moment().format() : null
    },

    ...mapState({
      uploading: store => store.core.storage.uploading
    })
  },

  methods: {
    go ($event) {
      const file = $event.target.files[0]
      const { size, type } = file

      this.upload({
        files: [file],
        path: this.path
      })
        .then(res => {
          const { bucket, etag, extension, filename, path, uuid } = res
          const {
            caption,
            description,
            requiresInternalSignature,
            requiresSignature,
            sent,
            sentAt,
            tag
          } = this

          this.create({
            bucket,
            uuid,
            extension,
            filename,
            path,
            etag,
            caption,
            description,
            tag,
            size,
            type,
            sent,
            sentAt,
            requiresInternalSignature,
            requiresSignature
          })
            .then(document => {
              this.$emit('uploaded', document)
            })
            .catch(err => this.$flash.failure(err))
        })
        .catch(err => this.$flash.failure(err))
        .finally(() => {
          // Clear the input value so we can upload the same file twice.
          this.$refs.input.value = ''
        })
    },

    preview ($event) {
      // TODO find method for file preview
    },

    props () {
      return Object.assign({}, this.$props)
    },

    ...mapActions({
      create: 'core/documents/create',
      upload: 'core/storage/upload'
    })
  }
}
</script>
